'use client';
import { classNames } from '@repo/ui/src/utils/classNames';

interface ToggleFilterButtonProps {
  label: string;
  isActive: boolean;
  onToggle: () => void;
}

const ToggleFilterButton = ({ label, isActive, onToggle }: ToggleFilterButtonProps) => (
  <button
    type="button"
    aria-pressed={isActive}
    onClick={onToggle}
    className={classNames(
      'flex items-center gap-1.5 px-4 py-2 rounded-full border text-sm font-medium transition-colors cursor-pointer whitespace-nowrap',
      isActive
        ? 'bg-neutral-800 text-white border-neutral-800'
        : 'border-warm-300 text-neutral-700 bg-white hover:bg-warm-100',
    )}
  >
    {label}
  </button>
);

export default ToggleFilterButton;
export type { ToggleFilterButtonProps };
